/**
 * SuperAdmin Tenants list — /superadmin/tenants (route shell).
 *
 * Screen impl in `./index-screen.tsx`, lazy-loaded. Platform-operator-only
 * surface (behind the /superadmin layout gate) — never on a trustee's path, so
 * it stays out of the initial bundle (it carries a create-tenant modal).
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/superadmin/tenants/')({
  component: lazyRouteComponent(() => import('./index-screen'), 'TenantsListScreen'),
});
